import { render, staticRenderFns } from "./address_former.vue?vue&type=template&id=8c4e6264&scoped=true&"
import script from "./address_former.vue?vue&type=script&lang=js&"
export * from "./address_former.vue?vue&type=script&lang=js&"
import style0 from "./address_former.vue?vue&type=style&index=0&id=8c4e6264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4e6264",
  null
  
)

export default component.exports